import React, { useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import DataAnalysisQuizContainer from "./DataAnalysisQuizContainer";
import DataAnalysisResults from "./DataAnalysisResults";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";

export interface DataAnalysisResult {
  questionId: number;
  selectedOption: number;
  scores: {
    insightExtraction: number;
    dataVisualization: number;
    decisionSupport: number;
  };
}

const DataAnalysisQuiz: React.FC = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    navigate("quiz");
  };

  return (
    <Routes>
      <Route
        index
        element={
          <UserInfoForm
            onSubmit={handleUserInfoSubmit}
            subtitle="Unlock the Power of Your Business Data"
          />
        }
      />
      <Route
        path="quiz"
        element={<DataAnalysisQuizContainer userInfo={userInfo} />}
      />
      <Route path="results" element={<DataAnalysisResults />} />
      <Route path="*" element={<Navigate to="/dataanalysis" replace />} />
    </Routes>
  );
};

export default DataAnalysisQuiz;
